import React from 'react';
import { ThemeProvider, createTheme, type SupportedColorScheme } from '@mui/material/styles';

import type { IAppProps } from '../App.typings';

const theme = createTheme({
    cssVariables: {
        colorSchemeSelector: '.Page_theme_%s',
    },
    colorSchemes: {
        light: true,
        dark: true,
    },
    defaultColorScheme: (Telegram.WebApp.colorScheme || 'light') as SupportedColorScheme,
});

export function withTheme<T extends IAppProps>(Base: React.FC<T>): React.FC<T> {
    return props => (
        <ThemeProvider theme={theme}>
            <Base {...props} />
        </ThemeProvider>
    );
}
